export default "__VITE_ASSET__Bxz7Qc3a__"